import styled, { css } from 'styled-components';

const is = (value) => typeof value !== 'undefined';
const prop = (value) => is(value) && value;
const colWidth = 38;

export const mixins = (props) => css`
  align-content: ${prop(props.alignContent)};
  align-items: ${prop(props.align)};
  flex-basis: ${prop(props.basis)};
  flex-grow: ${prop(props.grow)};
  flex-shrink: ${prop(props.shrink)};
  justify-content: ${prop(props.justify)};
  order: ${prop(props.order)};
  padding: ${prop(props.padding)};
  width: ${prop(props.width)};
`;

export const Col = styled.div`
  width: ${(p) => (p.size ? p.size * colWidth + 'px' : 'initial')};
  min-width: ${(p) => (p.size ? p.size * colWidth + 'px' : 'initial')};
  flex-basis: ${(p) => (p.part ? 100 / (36 / p.part) + '%' : 'initial')};
  &:not(:first-child) {
    margin-top: ${(p) => prop(p.gap)};
  }
  flex-direction: ${(p) => p.direction};
  display: ${(p) => p.flex && 'flex'};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  ${mixins}
  ${(p) =>
    p.gap &&
    css`
      margin-left: ${-p.gap / 2 + 'px'};
      margin-right: ${-p.gap / 2 + 'px'};
      & > ${Col} {
        margin-left: ${p.gap / 2 + 'px'};
        margin-right: ${p.gap / 2 + 'px'};
      }
    `}
    ${(p) =>
      p.rowGap &&
      css`
        &:not(:first-child) {
          margin-top: ${p.rowGap};
        }
      `}
`;
